import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import {
  List,
  useListRepository,
  DatePicker,
  useFilter,
  Filter,
  TextField
} from 'elentari'
import Snackbar from '../../components/CustomSnackbar'
import logLiberacaoAutomaticaRepository from './LogLiberacaoAutomaticaRepository'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import moment from 'moment'
import { formatCpf } from '../../utils/Formatter'
import { parseCpf, parsePlaca } from '../../utils/Parse'
import UsuarioAutocomplete from '../Usuarios/UsuarioAutocomplete'

const LogLiberacaoAutomaticaFilter = () => {
  const filter = useFilter({})

  return (
    <Filter {...filter} labels={{ find: 'Buscar', clear: 'Limpar' }}>
      <Grid container spacing={3}>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataInicio"
            label="Data Início"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="dataFim"
            label="Data Fim"
            component={DatePicker}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            name="usuarioId"
            label="Usuário"
            component={UsuarioAutocomplete}
            fullWidth
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            name="cpf"
            label="CPF Motorista"
            parse={parseCpf}
            component={TextField}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            component={TextField}
            label="Placa"
            parse={parsePlaca}
            name="placa"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

const LogLiberacaoAutomatica = ({ classes, history, ...props }) => {
  const [mensagem, setMensagem] = useState('')
  const [ability] = useAbility()

  const listOptions = {
    defaultOrder: 'id desc',
    fields: {
      ultimaSolicitacaoId: {
        label: 'Solicitação',
        format: value => `#${value}`
      },
      data: {
        label: 'Data',
        format: data => moment(data).format('DD/MM/YYYY HH:mm:ss')
      },
      usuario: {
        label: 'Usuário',
        format: data => data.usuario
      },
      cpf: {
        label: 'CPF Motorista',
        format: data => formatCpf(data) ?? '-'
      },
      placa: {
        label: 'Placa',
        format: data => (data ? parsePlaca(data) : '-')
      }
    }
  }

  const listHook = useListRepository({
    repository: logLiberacaoAutomaticaRepository,
    defaultSort: 'id desc',
    path: 'log-liberacao-automatica'
  })
  const actions = getListActions(ability, listHook, 'logLiberacaoAutomatica')

  return (
    <>
      <LogLiberacaoAutomaticaFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        onClickEdit={null}
        onClickNew={null}
        onClickView={null}
        onClickRow={item =>
          history.push(`/solicitacoes/${item.ultimaSolicitacaoId}`)
        }
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default LogLiberacaoAutomatica
